import React, { useState, useEffect } from "react";
import { toast } from "react-hot-toast";
import { USER_ROLES } from "../../../Constants/Strings";

const RefreshSummaryModal = ({
  users = [],
  currentUserRole,
  onSubmit,
  onClose,
}) => {
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [month, setMonth] = useState(() => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;
  });


  useEffect(() => {
    if (currentUserRole !== USER_ROLES.HR) {
      setSelectedUsers([]);
    }
  }, [currentUserRole]);

  const handleSubmit = () => {
    if (!month) {
      toast.error("Please select a month.");
      return;
    }

    if (currentUserRole === USER_ROLES.HR && selectedUsers.length === 0) {
      toast.error("Please select at least one user.");
      return;
    }

    onSubmit({ month, user_ids: selectedUsers });
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 transition-opacity duration-300">
      <div className="bg-white rounded-xl p-6 w-[90%] max-w-md shadow-2xl transform transition-all duration-300 scale-100">
        <h2 className="text-2xl font-bold mb-6 text-primary">
          Refresh Leave Summary
        </h2>

        {(currentUserRole === USER_ROLES.HR || USER_ROLES.DIRECTOR_MANAGEMENT.includes(currentUserRole)) && (
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">
              Select Users
            </label>
            {/* Users Multi-Select (only for HR) */}
            <div className="border border-gray-200 rounded-lg p-3 h-40 overflow-y-auto mb-4 shadow-inner bg-gray-50">
              {users.map((u) => (
                <label
                  key={u.id}
                  className="flex items-center gap-3 p-1 rounded hover:bg-gray-100 transition-colors cursor-pointer"
                >
                  <input
                    type="checkbox"
                    value={u.id}
                    checked={selectedUsers.includes(String(u.id))}
                    onChange={(e) => {
                      const value = e.target.value;
                      setSelectedUsers((prev) =>
                        prev.includes(value)
                          ? prev.filter((id) => id !== value)
                          : [...prev, value]
                      );
                    }}
                    className="h-4 w-4 text-primary focus:ring-2 focus:ring-primary rounded"
                  />
                  <span className="text-gray-700 font-medium">
                    {u.first_name} {u.last_name}
                  </span>
                </label>
              ))}
            </div>
          </div>
        )}

        {/* Month Picker */}
        <div className="mb-6">
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            Select Month
          </label>
          <input
            type="month"
            className="w-full border border-gray-300 rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition"
            value={month}
            onChange={(e) => setMonth(e.target.value)}
            min={new Date().toISOString().slice(0, 7)}
          />
        </div>

        {/* Buttons */}
        <div className="flex justify-end gap-3">
          <button
            className="px-5 py-2 bg-gray-200 text-gray-700 font-medium rounded-lg hover:bg-gray-300 transition"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="px-5 py-2 bg-primary text-white font-semibold rounded-lg hover:bg-green-600 transition shadow-md hover:shadow-lg"
            onClick={handleSubmit}
          >
            Refresh
          </button>
        </div>
      </div>
    </div>
  );
};

export default RefreshSummaryModal;
